<!-- eslint-disable -->
<template>
	<div id="access_options" v-if="!isLoading"
		:style="removeBgbyWindowSize"		
	>
		<div class="bar"
			:style="{
				'background': colors.primary
			}"		
		></div>
		<div class="wrapper">
			<div
			class="access_content"
			v-show="wsExist"
			>
				<div class="logo">
					<div class="svg-logo" v-if="game == 'repense'">
						<LogoRepense></LogoRepense>
					</div>
					<div class="svg-logo" v-if="game == 'decode'">
						<!-- <img :src="image" alt=""> -->
						<LogoDecode></LogoDecode>
					</div>
					<div v-if="game != 'decode' && game != 'repense'" class="center-flex">
						<svg version="1.1" id="Layer_1" class="svg-logo-huddle" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 610 610" xml:space="preserve">
							<path class="st0" fill="#1D2029" d="M540.25,605.25H70.11c-35.86,0-64.93-29.07-64.93-64.93V70.18c0-35.86,29.07-64.93,64.93-64.93h470.14
								c35.86,0,64.93,29.07,64.93,64.93v470.14C605.18,576.18,576.11,605.25,540.25,605.25z"/>
							<g>
								<path class="st1" fill="#02E5DA" d="M157.81,152.89h69.18v110.77c7.2-6.66,16.86-12.46,28.99-17.39c12.13-4.93,23.92-7.4,35.39-7.4
									c23.99,0,41.05,6.67,51.18,20c10.13,13.33,15.19,32.53,15.19,57.58V457.6h-69.18V325.64c0-8.53-2.34-14.8-7-18.79
									c-4.67-4-10.74-6-18.2-6c-6.67,0-13.13,1.34-19.39,4c-6.27,2.67-11.93,6-16.99,10V457.6h-69.18V152.89z"/>
								<g>
									<path class="st1" fill="#02E5DA" d="M489.23,457.6h-70.85l-77.85-304.71h70.78L489.23,457.6z"/>
								</g>
							</g>
						</svg>
					</div>
				</div>
				<div class="program_info">
					<div class="slogan" 
						:style="{
							color: colors.primary
						}"
					>{{ workspace.title }}</div>
				</div>
				<router-link to="/register-email" class="container-button" v-if="!noRegisterWorkspaces.includes(workspace.id)">
					<button
						class="option-button"
						:style="{
							background: colors.secondary,
							borderTop: `7px solid ${colors.secondary}`,
							borderBottom: `4px solid ${colors.theme == 'dark' ? '#001324' : '#cecece'}`,
							color: colors.theme !== 'dark' ? '#000' : '#fff'
						}"
					>
						{{ $t("views.AccessOption.option_button1") }}
					</button>
				</router-link>
				<router-link to="/login" class="container-button">
					<button
						class="option-button secondary"
						:style="{
							background: 'transparent',
							border: `1px solid #fff`,
							color: colors.theme !== 'dark' ? '#000' : '#fff'
						}"
					>
						{{ $t("views.AccessOption.option_button2") }}
					</button>
				</router-link>
				<div class="copyright"
					:style="{
						color: colors.theme !== 'dark' ? '#000' : '#fff',
						fill: colors.theme !== 'dark' ? '#000' : '#fff'
					}"				
				>
					<span>{{ $t("views.AccessOption.copyright") }}</span>
					<LogoHuddle></LogoHuddle>
				</div>
			</div>
			<alert-error
				:textError="alertErrorInfo.titleText"
				:nameButton="alertErrorInfo.nameButton"
				:showButton="alertErrorInfo.showButton"
				v-show="alertErrorInfo.show"
			></alert-error>
		</div>
		<Loader v-if="isLoading" loaderStyle="circle"></Loader>
	</div>
</template>

<script>
/* eslint-disable  */
import defaultFooter from "../../components/Sections/FooterDefault";
import AlertError from "../../components/Alerts/AlertError";
import LogoRepense from "../../components/customIcons/logoRepense";
import LogoDecode from "../../components/customIcons/logoDecode";
import LogoHuddle from "../../components/customIcons/logoHuddle";
import Bus from "@/main.js";
import { styleVueCreator } from "../../helpers/customizer";
import i18n from "@/plugins/i18n";
import Loader from '../../components/Alerts/Loader'
import servCat from "../../api/servCat"
import authService from "../../api/authentication"


const moment = require("moment");
moment.locale("pt-br");


export default {
	components: {
		"default-footer": defaultFooter,
		"alert-error": AlertError,
		LogoRepense,
		LogoDecode,
		LogoHuddle,
		Loader
	},

	data() {
		return {
			workspace:{
				tite: "",
				id: ""
			},
			alertErrorInfo: {
				titleText: this.$t("views.AccessOption.alertErrorInfo.titleText"),
				nameButton: this.$t("views.AccessOption.alertErrorInfo.nameButton"),
				showButton: false,
				show: false
			},
			game: "",
			user: {},
			token: "",
			colors: {},
			wsExist: false,
			hasColors: false,
			isLoaded: false,
			isLoading: true,
			noRegisterWorkspaces: ["sPCGDV1ja9639qzApX3E","ffocEYR9N4uxEDkGodO6","Oj6FEicMCYo4wCoFMSOq", "eBHsVn7mliHvdn7HpQ2w", "FQXA54XWkOIrdBdULMVk", "VhqgBeprpg5qe7u1wuB5","5KNimvGHpXAXJPCDQPE4", "2gjlFIwIVp7ETRhwRW5D", "hhUQOtfUdp48zA99vOXy","LX0x6uEQL8yBtn1DIDMt", "FleGP9zl82X5rdwY58FQ", "lBW2RdHCia5QiqX5a3qs"] //provisório
		};
	},
	async created() {
		Bus.$on("closeAlert", this.closeAlert);
		this.game = window.location.host.split(".")[0]
		// this.game = 'repense'//TODO: REMOVE!!!!!
		this.token = localStorage.getItem("token")
		this.user = JSON.parse(localStorage.getItem("user"))
		console.log(this.user)
		this.workspace.id = this.$route.query.workspaceId;
		localStorage.setItem("game-redirect", this.game);
		localStorage.setItem("workspaceId", this.workspace.id );
		try {
			const workspaceIdReq = await servCat.get(`/workspaces/${this.workspace.id }`);
			this.changeLocale(workspaceIdReq.data.workspace.language);
			localStorage.setItem("workspaceTitle", workspaceIdReq.data.workspace.title )
			if(workspaceIdReq.data.workspace.externalId) 
				this.showAlert(true,"Você está acessando o link de uma vaga integrada a uma outra plataforma. Para realizar o game, você deve acessá-lo diretamente por ela.")
			const endDate = moment(workspaceIdReq.data.workspace.endDate);
			const startDate = moment(workspaceIdReq.data.workspace.startDate);
			const now = moment(workspaceIdReq.data.now);
			const diff = endDate.diff(now, "seconds");
			let defaultColor = {
				primary: "#58fdf4",
                secondary: "#fe4778",
                theme: "dark",
                clientLogoPath: "",
                dark: {
                    from: "#001324",
                    to: "#1b2933",
                },
                light: {
                    to: "#fff",
                    from: "#ccc",
                }
			}
			// this.colors = (await workspaceIdReq.data.workspace.colors) ? workspaceIdReq.data.workspace.colors : defaultColor; //TODO: REMOVE!!!!!
			this.colors = defaultColor
			localStorage.setItem("colors", JSON.stringify(this.colors));

			if (endDate.diff(now, "seconds") < 0) this.showAlert(true, this.$t("views.AccessOption.titleText[0]"))
			if (startDate.diff(now, "seconds") > 0 && workspaceIdReq.data.workspace.startDate) this.showAlert(true, this.$t("views.AccessOption.titleText[1]"))
			this.workspace.title = workspaceIdReq.data.workspace.title;
			this.wsExist = true;
		} catch (error) {
			//TODO: make a error message showing up instead console.log error
			// console.error("Erro ao consultar Workspace ID:", error);
			// console.error("Erro ao consultar Workspace ID:", error.response);
			alert(`Erro ao verificar o processo!`)
			return
			// return alert(`Erro ao verificar o processo: ${error.response.data.response}`)
		}
		if(this.user){
			try {
				const userReq = await authService.post(`/verify?token=${this.token}`)
				// console.log("userReq: ", userReq.data)
				// console.log("this.user.id: ", this.user.id)
				if(userReq.data.userId == this.user.id) this.$router.push("/middleware-game")
			} catch (error) {
				//TODO: make a error message showing up instead console.log error
				// console.error("error: ", error)
				// localStorage.removeItem("user, token")
			}
		}
		this.isLoading = false

	},
	computed: {
		image() {
			if (this.game != "repense" || this.game != 'localhost:8080') return require(`../../assets/${this.game}-logo.png`);
		},
		removeBgbyWindowSize(){
			const nobg = {
				'background':`linear-gradient(180deg, ${this.colors[this.colors.theme].from} 0%,  ${this.colors[this.colors.theme].to} 100%)`
			}
			const bg = {
				'background':`url(/img/background-${this.colors.theme}.png), linear-gradient(180deg, ${this.colors[this.colors.theme].from} 0%,  ${this.colors[this.colors.theme].to} 100%)`
			}
			return window.outerWidth >= 720 ? nobg : bg
		}		
	},
	methods: {
		changeLocale(locale) { i18n.locale = locale; },
		style(colors, styles) { return styleVueCreator(colors, styles); },
		showAlert(isVisible, titleText){
			this.alertErrorInfo.show = isVisible
			this.alertErrorInfo.titleText = titleText
		},
	}
};
</script>

<style lang="scss">
#access_options {
	background-size: cover !important;
	.wrapper{
		height: 98vh;
	}
	.bar{
		height: 2vh;
	}
	#loader {
		position: fixed;
		top: 0;
		height: 100vh;
		width: 100vw;
		background-color: #333;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
.access_content {
	height: 90vh;
	padding: 0 60px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;

	.logo {
		display: flex;
		align-items: center;

		img {
			max-width: 135px;
		}
		.svg-logo {
			width: 220px;
		}
		.center-flex{
			display: flex;
			align-items: center;
			justify-content: center;

			.svg-logo-huddle{
				width: 25%;
			}
		}
	}
	.program_info {
		margin: 5% 0;
		text-align: center;

		.slogan {
			font-weight: 600;
		}
	}
	.copyright {
		margin: 40px 0 0 0;
		display: flex;
		flex-direction: column;
		align-items: center;

		span {
			letter-spacing: 2px;
			font-size: 12px;
			padding: 0 0 15px 0;
			text-transform: uppercase;
		}

		img,
		svg {
			max-width: 85px;
		}
	}
}

.container-button {
	width: 85%;
	margin-top: 5%;
	max-width: 420px;

	.option-button {
		width: 100%;
		border: none;
		padding: 18px 0 23px;
		letter-spacing: 3px;
		text-transform: uppercase;
		font-weight: 900;
		font-size: 13px;
		color: #30353a;
		background-color: #fbf872;
		border-top: 7px #fbf872 solid;
		border-bottom: 7px #d8d365 solid;
		outline: none;
		border-radius: 50px;
	}

	.option-button.secondary {
		background-color: transparent;
		border-top: none;
		border-bottom: none;
    	padding: 23px 0;
	}

	.button-action-start {
		padding: 15px 0 10px;
		border-top: 7px white solid;
		border-bottom: 7px #fbf872 solid;
	}

	.button-actions-finish {
		padding: 10px 0 15px;
		border-top: 7px #fbf872 solid;
		border-bottom: 7px #d8d365 solid;
	}
}

@media only screen and (min-width: 800px) {
	#access_options {
		.access_content {
			.program_info {
				margin: 40px 0 20px;
			}

			.container-button {
				width: 300px;
				margin: 20px;

				.option-button {
					font-size: 15px;
				}
			}

			.copyright {
				span {
					padding: 0 0 10px 0;
				}
			}
		}
	}
}
// @media only screen and (min-width: 920px) {
// 	#access_options {
// 		background: none;
// 	}
// }
</style>
